export const roveHandsetIconName = 'rove-handset';

const roveHandsetPath =
   'M9.5,1H14.5A4.5,4.5 0 0 1 19,5.5V18.5A4.5,4.5 0 0 1 14.5,23H9.5A4.5,4.5 0 0 1 5,18.5V5.5A4.5,4.5 0 0 1 9.5,1Z' +
   'M10.4,2.6H13.6A0.4,0.4 0 0 1 14,3V3A0.4,0.4 0 0 1 13.6,3.4H10.4A0.4,0.4 0 0 1 10,3V3A0.4,0.4 0 0 1 10.4,2.6Z' +
   'M8.6,5H15.4A1.6,1.6 0 0 1 17,6.6V10.4A1.6,1.6 0 0 1 15.4,12H8.6A1.6,1.6 0 0 1 7,10.4V6.6A1.6,1.6 0 0 1 8.6,5Z' +
   'M10.6,15A1.4,1.4 0 1 0 13.4,15A1.4,1.4 0 1 0 10.6,15Z' +
   'M7.7,17.4H16.3A0.7,0.7 0 0 1 17,18.1V18.1A0.7,0.7 0 0 1 16.3,18.8H7.7A0.7,0.7 0 0 1 7,18.1V18.1A0.7,0.7 0 0 1 7.7,17.4Z' +
   'M7.7,20H16.3A0.7,0.7 0 0 1 17,20.7V20.7A0.7,0.7 0 0 1 16.3,21.4H7.7A0.7,0.7 0 0 1 7,20.7V20.7A0.7,0.7 0 0 1 7.7,20Z';

export const roveHandsetIconSvg = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
   <path fill-rule="evenodd" d="${roveHandsetPath}"/>
</svg>`;
